import { render } from "./HomeIdea.vue?vue&type=template&id=49802b7c&scoped=true"
import script from "./HomeIdea.vue?vue&type=script&lang=js"
export * from "./HomeIdea.vue?vue&type=script&lang=js"

import "./HomeIdea.vue?vue&type=style&index=0&id=49802b7c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49802b7c"]])

export default __exports__